import { render } from "./donutsTimespent.vue?vue&type=template&id=0d4f45da&scoped=true"
import script from "./donutsTimespent.vue?vue&type=script&lang=js"
export * from "./donutsTimespent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0d4f45da"

export default script